var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDistributionScatter = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 33,
  viewBox: "0 0 33 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.2388 4.29688H32.7612",
  className: "chart-axis-line-stroke",
  strokeWidth: 0.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 10.3242H32.5224",
  className: "chart-axis-line-stroke",
  strokeWidth: 0.5
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M1 15.4844H32.5224",
  className: "chart-axis-line-stroke",
  strokeWidth: 0.5
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M1 21.6758H32.5224",
  className: "chart-axis-line-stroke",
  strokeWidth: 0.5
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M1.2388 27.2227H32.7612",
  className: "chart-axis-line-stroke",
  strokeWidth: 0.5
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M1 0V32H33",
  className: "chart-axis-line-stroke",
  strokeWidth: 1.5
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 4.91022,
  cy: 27.2381,
  r: 1.99982,
  className: "chart-qualitative-01"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.4868,
  cy: 27.2381,
  r: 1.99982,
  className: "chart-qualitative-01"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 4.0625,
  r: 2,
  className: "chart-qualitative-01"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 29.5754,
  cy: 4.0625,
  r: 2,
  className: "chart-qualitative-01"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.99988,
  cy: 10.2577,
  r: 1.99988,
  className: "chart-qualitative-02"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 28.3082,
  cy: 10.2577,
  r: 1.99988,
  className: "chart-qualitative-02"
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 15.4219,
  r: 2,
  className: "chart-qualitative-01"
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 29.3128,
  cy: 21.6133,
  r: 2,
  className: "chart-qualitative-02"
})), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.7244,
  cy: 21.6133,
  r: 2,
  className: "chart-qualitative-02"
})), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.0968,
  cy: 21.6133,
  r: 2,
  className: "chart-qualitative-02"
})));
export { SvgDistributionScatter as ReactComponent };
export default __webpack_public_path__ + "distribution_scatter.84b4acc3024efd8436d38f416225222b.svg";